import { PlannerGlobals } from 'src/components/Planner/planner/planner-globals';
import { redrawNotes } from 'src/components/Planner/planner/notes';
import { getDeviceById } from 'src/components/Planner/planner/uDev';
import { redrawDevice } from 'src/components/Planner/planner/deviceDrawing';
import {
    CreateDevNoteAction,
    CreateSoleNoteAction,
    ModifyNoteAction,
} from 'src/components/Planner/planner/history/note-actions';

export interface NotePayload {
    noteId: number;
    x: number;
    y: number;
    text: string;
    color: string;
}

export interface DevNotePayload {
    deviceId: string | number;
    text: string;
    color: string;
}

export interface CreatedDevNotePayload {
    noteId: number;
    deviceId: string | number;
    text: string;
    color: string;
}

export function applyCreatedNote(note: NotePayload): void {
    PlannerGlobals.notes.push({
        note_id: note.noteId,
        x: note.x,
        y: note.y,
        text: note.text,
        color: note.color,
        ghost: false,
    });
    const action = new CreateSoleNoteAction(note.noteId, note.x, note.y, note.text, note.color);
    PlannerGlobals.plannerHistoryManager?.addHistoryEntry(action);
    if (PlannerGlobals.notes_on) {
        redrawNotes();
    }
}

export function applyUpdatedNote(
    note: NotePayload,
    previous: { text: string; color: string },
): void {
    const existing = PlannerGlobals.notes.find(
        (n: { note_id: number }) => n.note_id === note.noteId,
    );
    if (existing) {
        existing.text = note.text;
        existing.color = note.color;
    }
    const action = new ModifyNoteAction(
        note.noteId,
        previous.text,
        previous.color,
        note.text,
        note.color,
        'sole',
    );
    PlannerGlobals.plannerHistoryManager?.addHistoryEntry(action);
    if (PlannerGlobals.notes_on) {
        redrawNotes();
    }
}

export function applyCreatedDevNote(note: CreatedDevNotePayload): void {
    const dev = getDeviceById(note.deviceId);
    if (dev) {
        dev.noteId = note.noteId;
        dev.hasNote = true;
        dev.noteTxt = note.text;
        dev.noteColor = note.color;
    }
    const action = new CreateDevNoteAction(note.deviceId, note.text, note.color);
    PlannerGlobals.plannerHistoryManager?.addHistoryEntry(action);
    if (PlannerGlobals.notes_on && dev) {
        redrawDevice(dev.deviceId);
    }
}

export function applyUpdatedDevNote(
    note: DevNotePayload,
    previous: { text: string; color: string },
): void {
    const dev = getDeviceById(note.deviceId);
    if (dev) {
        dev.noteTxt = note.text;
        dev.noteColor = note.color;
    }
    const action = new ModifyNoteAction(
        note.deviceId,
        previous.text,
        previous.color,
        note.text,
        note.color,
        'dev',
    );
    PlannerGlobals.plannerHistoryManager?.addHistoryEntry(action);
    if (PlannerGlobals.notes_on && dev) {
        redrawDevice(dev.deviceId);
    }
}
